import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorYield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.9 4.11a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm-9.75 8.25c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75Z"
    />
    <path
      fill="#F7A600"
      d="M11.496 7.99c.153-.496.854-.496 1.007 0l.795 2.572h2.644c.504 0 .72.64.32.946l-2.161 1.65.811 2.627a.527.527 0 0 1-.823.574l-2.09-1.596-2.088 1.596a.527.527 0 0 1-.824-.574L9.9 13.16l-2.161-1.651a.527.527 0 0 1 .32-.946H10.7l.795-2.572ZM18.9 1.9l.091.55a4.185 4.185 0 0 0 3.307 3.415 4.185 4.185 0 0 0-3.307 3.415l-.091.55-.088-.526a4.226 4.226 0 0 0-3.31-3.439 4.185 4.185 0 0 0 3.306-3.415l.092-.55Z"
    />
  </svg>
);
export default SvgTwoColorYield;
